import DefaultModal from '@/src/common/components/marketing/modals/DefaultModal'
import {
    ModalBodyWrapper,
    ModalButtonsWrapper,
    ModalHeader,
} from '@/src/common/components/elements/Modals/StyledModalComponents'
import Button from '@/src/common/components/marketing/buttons/Button'
import {
    CARRIER_FONT_HANDWRITTEN,
    HANDWRITTEN_FEE,
} from '@/src/modules/build-a-card/constants'
import Image from 'next/image'
import { useBasicGiftCardContext } from '@/src/common/contexts/BasicGiftCardContext'

const HandwrittenModal = ({
    showModal,
    setShowModal,
}: {
    showModal: boolean
    setShowModal: Function
}) => {
    const { setFontSelection } = useBasicGiftCardContext()

    return (
        <DefaultModal
            showModal={showModal}
            setShowModal={setShowModal}
            testId={'handwritten-modal'}
            width={'small-medium'}
        >
            <ModalHeader>
                Make your <span className={'gradient-text'}>PerfectGift</span>{' '}
                even more personal
            </ModalHeader>
            <ModalBodyWrapper>
                <p style={{ marginTop: 0 }}>
                    PerfectGift is happy to introduce handwritten greeting
                    cards! Keep your thoughtful message, just skip having to
                    write it.
                </p>
                <Image
                    src={'/images/greeting-card-preview-v2.png'}
                    alt={'Greeting Card Preview Image'}
                    width={565}
                    height={382}
                    style={{
                        width: 430,
                        boxShadow: 'gray 0px 1px 6px -1px',
                    }}
                />
                <ModalButtonsWrapper gap={'5px'}>
                    <Button
                        label={`Upgrade for $${HANDWRITTEN_FEE}`}
                        variant={'primary'}
                        textTransform={'uppercase'}
                        width={'standard'}
                        showArrow={true}
                        onClick={() => {
                            setFontSelection(CARRIER_FONT_HANDWRITTEN)
                            setShowModal(false)
                        }}
                    />
                    <Button
                        label={'No thanks'}
                        variant={'primaryOutline'}
                        textTransform={'uppercase'}
                        width={'standard'}
                        showArrow={true}
                        onClick={() => setShowModal(false)}
                    />
                </ModalButtonsWrapper>
            </ModalBodyWrapper>
        </DefaultModal>
    )
}

export default HandwrittenModal
